<template>
  <div :class="this.$router.history.current.name === 'DogRacing' ? 'help-window-dr' : this.$router.history.current.name === 'Bingo49' ? 'help-window-b-49' : 'help-window'">
      <div class="help-status-bar">
        <div 
          class="help-close-button"
          @click="closeHelpMenu"
        >
        </div>
      </div>
      <div class="help-main-content">
        <div class="help-cursor-holder left-holder">
          
        </div>
        <VueSlickCarousel v-if="this.$router.history.current.name === 'LuckyBalls'" v-bind="settings" >
          <HelpFirstPage />
          <HelpSecondPage />
          <HelpThirdPage />
          <HelpFourthPage />
          <HelpFifthPage />
          <HelpSixthPage />
          <HelpSeventhPage />
          <HelpEightPage />
          <PayTable />
        </VueSlickCarousel>
        <div class="help-cursor-holder right-holder">
        </div>
      </div>
      <div class="help-status-bar lower"></div>
  </div>
</template>

<script>
import {translate} from '../../../assets/common/lang';
import VueSlickCarousel from 'vue-slick-carousel'
import HelpFirstPage from './help-modal-pages/HelpFirstPage';
import HelpSecondPage from './help-modal-pages/HelpSecondPage';
import HelpThirdPage from './help-modal-pages/HelpThirdPage';
import HelpFourthPage from './help-modal-pages/HelpFourthPage';
import HelpFifthPage from './help-modal-pages/HelpFifthPage';
import HelpSixthPage from './help-modal-pages/HelpSixthPage';
import HelpSeventhPage from './help-modal-pages/HelpSeventhPage';
import HelpEightPage from './help-modal-pages/HelpEightPage';
import PayTable from './help-modal-pages/Paytable';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  components: { VueSlickCarousel, HelpFirstPage, HelpSecondPage, HelpThirdPage, HelpFourthPage, HelpFifthPage, HelpSixthPage, HelpSeventhPage,
      PayTable ,HelpEightPage},
  methods: {
    closeHelpMenu() {
      this.$emit('closeHelpMenu');
    },
    translate(word) {
      return translate(word);
    }
  },
  data() {
      return {
        settings: {
          arrows: true
        }
      }
    },
}
</script>
